import React from 'react';
import PropTypes from 'prop-types';
import {Card, CardHeader, CardBody, CardTitle, CardText} from 'reactstrap';
import {FormattedMessage} from "react-intl";

class AdvertDetail extends React.Component {
    static propTypes = {
        advert: PropTypes.shape({
            name: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            photoUrl: PropTypes.string.isRequired,
            priceVoice: PropTypes.string,
            priceText: PropTypes.string,
            serviceTypes: PropTypes.arrayOf(PropTypes.shape({
                key: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            })).isRequired,
        }).isRequired,
        showPrices: PropTypes.bool,
    };

    render() {
        const {advert, showPrices, className} = this.props;

        let classes = "card-promo card-promo--preview ";
        if (className) {
            classes += className;
        }

        return (
            <Card className={classes}>
                <CardHeader>
                    <img src={advert.photoUrl} alt={advert.name}/>
                    <strong className="card-promo__name">{advert.name}</strong>
                    <br/>{advert.serviceTypes.map(type => (type.name)).join(', ')}
                </CardHeader>
                <CardBody>
                    <CardTitle tag="h3">
                        {advert.title}
                    </CardTitle>
                    <CardText tag="p">
                        {advert.text}
                    </CardText>
                    {showPrices &&
                    <CardText>
                        <FormattedMessage id="advert.detail.voice_price"
                                          defaultMessage="Call price (per minute)"/>: {advert.priceLevelVoice.description}
                        <br/>
                        {advert.priceLevelText &&
                        <span>
                            <FormattedMessage id="advert.detail.text_price"
                                          defaultMessage="SMS price"/>: {advert.priceLevelText.description}
                        </span>
                        }
                    </CardText>
                    }
                </CardBody>
            </Card>
        )
    }
}

export default AdvertDetail;


// WEBPACK FOOTER //
// ./src/components/AdvertDetail.jsx